import NZContact from "../../../components/NZComponent/home/NZContact/NZContact";
import PETROLSIDE from "../../../assets/images/Orchardised_Tuatara.jpg";
import { useNavigate } from "react-router";
import PETROLModels from "../../../components/NZComponent/NzPetrol/PETROLModels";
import HighLevelSpecs from "../../../components/NZComponent/NzPetrol/HighLevelSpecs";
import NZNZPetrolGregFarrier from "../../../components/NZComponent/NzPetrol/NZNZPetrolGregFarrier";
import NZElectricaTV from "../../../components/NZComponent/NzPetrol/NZElectricaTV";
import HomeIcon from "../../../assets/svg/HomeIcon.svg";
import RightSideArrow from "../../../assets/svg/RightSideArrow.svg";
import NZGregFarrier from "../../../components/NZComponent/home/NZGregFarrier/NZGregFarrier";
import NZGregAssociates from "../../../components/NZComponent/home/NZGregAssociates/NZGregAssociates";
import NzOrchardisedFeatures from "../../../components/NZComponent/NzOrchardised/NzOrchardisedFeatures";
import NzOrchardisedModels from "../../../components/NZComponent/NzOrchardised/NzOrchardisedModels";
import NzOrchardisedDetails from "../../../components/NZComponent/NzOrchardised/NzOrchardisedDetails";
import E_Logo from "../../../assets/images/E_Logo.png";
import { useRef } from "react";
import { useState } from "react";
import { useEffect } from "react";
import SEOMetadata from "../../../components/SEOMetadata";
import { seoConfig } from "../../../config/seoConfig";

const NzOrchardised = () => {
  let navigate = useNavigate();
  const textRef = useRef(null);
  const eRef = useRef(null);
  const [offset, setOffset] = useState(0);
  const [spacing, setSpacing] = useState(0);
  useEffect(() => {
    const handleResize = () => {
      if (textRef.current && eRef.current) {
        const textSize = window.getComputedStyle(textRef.current).fontSize;
        const textHeight = parseFloat(textSize); // Convert to number
        setOffset(textHeight * 0.1); // Adjust dynamically based on font size
        const eWidth = eRef.current.getBoundingClientRect().width;
        setSpacing(eWidth * 0.98);
      }
    };

    // Initial calculation
    handleResize();

    // Add resize event listener
    window.addEventListener("resize", handleResize);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const seoData = seoConfig.nz.orchardised;

  return (
    <>
      <SEOMetadata
        title={seoData.title}
        description={seoData.description}
        keywords={seoData.keywords}
      />
      <div>
        <div className="px-[12px] py-[6px] bg-[#F0F0F0] flex items-center">
          <img
            src={HomeIcon}
            alt="HomeIcon"
            className="cursor-pointer"
            onClick={() => navigate("/")}
          />
          <div className="flex items-center mx-[5px]">
            <img src={RightSideArrow} alt="RightSideArrow" />
            <img src={RightSideArrow} alt="RightSideArrow" />
          </div>
          <div className="text-[14px] leading-[24px] text-[#383838] montserrat-semi-bold">{`Orchardised`}</div>
        </div>
        <div className="grid lg:grid-cols-2 grid-cols-1 gap-[30px] md:gap-[50px]">
          <div className="h-[300px] md:h-[720px] w-full lg:h-auto xl:h-[680px]" >
            <div
              className="h-[300px] w-full md:h-full "
              style={{
                backgroundImage: `url(${PETROLSIDE})`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            />
          </div>
          <div className="p-[50px] md:pt-[200px] sm:pt-[50px] py-[20px] text-left">
            <div
              className="text-white kuunari-bold 
                       text-[20px] 
                       md:text-[40px] 
                       lg:text-[60px]  
                       leading-[32px]
                       md:leading-[42px] 
                       lg:leading-[62px]
                       mb-[11px]                        
                       max-w-[511px] 
                       mx-auto"
              style={{ textShadow: "2px 4px 6px #000000" }}
            >
              <span
                ref={textRef}
                className="relative inline-block"
                style={{ paddingLeft: `${spacing}px` }}
              >
                <span
                  ref={eRef}
                  style={{ bottom: `${offset}px` }}
                  className="font-Dancing font-extrabold text-[#7bc25c] inline-block absolute left-0 
                  text-[22px] 
             md:text-[52px] 
             lg:text-[78px]  "
                >
                  e
                </span>
                Tuatara
              </span>{" "}
              Orchardised UTV1500E-2-OR
            </div>
          </div>
        </div>

        <div>
          <NzOrchardisedFeatures />
          <NzOrchardisedModels />
          <NzOrchardisedDetails />
        </div>
        <NZGregFarrier
          bg={"#fff"}
          slogan="“THIS IS HANDS DOWN THE MOST VERSATILE ATV I HAVE PURCHASED FOR THE FARM.”"
        />
        <div id="contact-form">
          <NZContact />
        </div>
        {/* <NZGregAssociates /> */}
      </div>
    </>
  );
};
export default NzOrchardised;
